import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/css/admin_style.css';
import './assets/css/styles.css';
import { ConfigProvider } from 'antd';
import AppStack from './routes/AppStack.Site';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#d9232d',
        },
      }}
    >
      <AppStack />
    </ConfigProvider>
  </React.StrictMode>
);
